import React, {useEffect} from 'react';
import InputNumberField
    from '@src/components/_views/configurable/import-view/file-list/additional-row/fields/InputNumberField';
import {useFormContext, useWatch} from 'react-hook-form';
import {TForm} from '@src/components/_views/configurable/import-view/file-list/.types';

export default function SkipFirstRows() {
    const {control, setValue} = useFormContext<TForm>();
    const values = useWatch<TForm>({name: ['hasHeader', 'skipFirstRows'], control});
    const hasHeader = values?.[0] === true;
    const skipFirstRows = +(values?.[1] ?? 0);

    useEffect(() => {
        if (hasHeader && skipFirstRows < 1) {
            setValue('skipFirstRows', 1);
        }
    }, [hasHeader, setValue, skipFirstRows]);

    return <InputNumberField
            name="skipFirstRows"
            label="List:ImportRecords.item-config.fields.skip-first-rows"
            min={hasHeader ? 1 : 0}
    />;
}
